import e from"react";var t=e.createContext({}),r=function(r){var a=r.children,i=r.setTitle;return e.createElement(t.Provider,{value:{setTitle:i}},a)};export{t as DialogContext,r as DialogProvider};
